import React from 'react';
import Hero from './components/Hero';
import ValueProps from './components/ValueProps';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Booking from './components/Booking';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-stone-50 font-sans selection:bg-slate-200 selection:text-slate-900">
      <main>
        <Hero />
        <ValueProps />
        <Experience />
        <Skills />
        <Booking />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}

export default App;